import { render, staticRenderFns } from "./AddPrivateReserve.vue?vue&type=template&id=47a713aa&scoped=true&"
import script from "./AddPrivateReserve.vue?vue&type=script&lang=js&"
export * from "./AddPrivateReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a713aa",
  null
  
)

export default component.exports